import { z } from 'zod';
import { OutcomeSchema } from './domain.js';
import { LenientSentimentSchema, SentimentLevelSchema } from './sentiment.js';
export const NextStepSchema = z.object({
    text: z.string().min(1),
    owner: z.string().default(''),
    /** ISO date (YYYY-MM-DD) or empty string when no date was agreed. */
    dueDate: z.string().default(''),
    done: z.boolean().default(false),
});
export const FollowUpEmailSchema = z.object({
    subject: z.string(),
    body: z.string(),
});
/** Output of the post-call engine, validated before it is stored as a MeetingSummary. */
export const PostCallResultSchema = z.object({
    summary: z.array(z.string()).min(1).max(10),
    nextSteps: z.array(NextStepSchema).max(15),
    painPoints: z.array(z.string()).max(15),
    requirements: z.array(z.string()).max(15),
    objections: z.array(z.string()).max(15),
    followUpEmail: FollowUpEmailSchema,
    suggestedOutcome: OutcomeSchema,
    sentiment: LenientSentimentSchema,
});
export const POSTCALL_JSON_SCHEMA = {
    type: 'object',
    additionalProperties: false,
    required: [
        'summary',
        'nextSteps',
        'painPoints',
        'requirements',
        'objections',
        'followUpEmail',
        'suggestedOutcome',
        'sentiment',
    ],
    properties: {
        summary: { type: 'array', items: { type: 'string' } },
        nextSteps: {
            type: 'array',
            items: {
                type: 'object',
                additionalProperties: false,
                required: ['text', 'owner', 'dueDate'],
                properties: {
                    text: { type: 'string' },
                    owner: { type: 'string' },
                    dueDate: { type: 'string' },
                },
            },
        },
        painPoints: { type: 'array', items: { type: 'string' } },
        requirements: { type: 'array', items: { type: 'string' } },
        objections: { type: 'array', items: { type: 'string' } },
        followUpEmail: {
            type: 'object',
            additionalProperties: false,
            required: ['subject', 'body'],
            properties: { subject: { type: 'string' }, body: { type: 'string' } },
        },
        suggestedOutcome: { type: 'string', enum: OutcomeSchema.options },
        sentiment: {
            type: 'object',
            additionalProperties: false,
            required: ['level', 'reason', 'signals'],
            properties: {
                level: { type: 'string', enum: SentimentLevelSchema.options },
                reason: { type: 'string' },
                signals: { type: 'array', items: { type: 'string' } },
            },
        },
    },
};
/** Compact brief about a client, built from previous meetings (see SPEC §6.3). */
export const ClientBriefSchema = z.object({
    clientId: z.string(),
    clientName: z.string(),
    industry: z.string().nullable(),
    notes: z.string().nullable(),
    meetingCount: z.number().int(),
    lastMeetingAt: z.string().nullable(),
    lastOutcome: OutcomeSchema.nullable(),
    peopleMet: z.array(z.string()),
    openNextSteps: z.array(z.object({ text: z.string(), owner: z.string(), dueDate: z.string() })),
    painPoints: z.array(z.string()),
    pastObjections: z.array(z.string()),
    recentSummaries: z.array(z.object({ date: z.string(), bullets: z.array(z.string()) })),
});
//# sourceMappingURL=postcall.js.map